import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'MEDIA_UPDATE',
    smsDelete : 'MEDIA_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        contact: [],
      
        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        contactLoading: false,
        contactError: false,

        contactInfoDetail:{},
        contactInfoLoading: false,
        contactInfoError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_CONTACT(state, contact) {
            state.contact = contact;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        CONTACT_LOADING (state, loading) {
            state.contactLoading = loading;
        },

        CONTACT_ERROR (state, hasError) {
            state.contactError = hasError;
        },

        SET_CONTACT_INFO_DETAIL (state, detail) {
            state.contactInfoDetail= detail;
        },

        CONTACT_INFO_LOADING (state, loading) {
            state.contactInfoLoading = loading;
        },

        CONTACT_INFO_ERROR (state, hasError) {
            state.contactInfoError = hasError;
        },
    },

    actions: {
        async fetchContact ({ commit }) {
            commit('CONTACT_LOADING', true);
            commit('CONTACT_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.contact_list, config);
                let response = result.data
                commit('SET_CONTACT', response.data);

            } catch(error) {
                commit('CONTACT_ERROR', true);
            }
            finally {
                commit('CONTACT_LOADING', false);
            }
        },
    

        async deleteContact({commit, dispatch}, payload) {
            let config = {
                headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.contact_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchContact')
            
            return response
        },

        // Contact Info
        async addContactInfo ({commit, dispatch}, payload) {
            commit('CONTACT_INFO_LOADING', true);
            commit('CONTACT_INFO_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try { 
                let response = await axios.post(V1API.create_contact_info, {
                    info: payload.contact
                }, config).then(result=>{
                    let data = result.data
                    return data
                });
                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchContactInfoDetail')
                return response
            } catch (e) {
                commit('CONTACT_INFO_ERROR', true);
            } finally {
                commit('CONTACT_INFO_LOADING', false);
            }
        },

        async fetchContactInfoDetail ({ commit }) {
            commit('CONTACT_INFO_LOADING', true);
            commit('CONTACT_INFO_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.get_contact_info_details, config);
                let response = result.data.data
                commit('SET_CONTACT_INFO_DETAIL', response);
            } catch(error) {
                commit('CONTACT_INFO_ERROR', true);
            } finally {
                commit('CONTACT_INFO_LOADING', false);
            }
        }
    },

    getters: {}
}
